<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.73151"
      y="9.07526"
      width="33.871"
      height="22.5806"
      rx="1.69355"
      :stroke="fill"
      stroke-width="1.12903"
    />
    <path
      d="M29.8438 13.0269C31.643 14.8409 32.6514 17.2702 32.6514 19.8011C32.6514 22.3319 31.643 24.7612 29.8438 26.5752L29.14 25.8871C30.7526 24.2556 31.6562 22.0739 31.6562 19.8011C31.6562 17.5283 30.7526 15.3465 29.14 13.715L29.8438 13.0269Z"
      :fill="fill"
    />
    <path
      d="M28.0259 24.7978C28.5443 24.1923 28.9664 23.5121 29.2765 22.7801C29.6766 21.8356 29.8826 20.8233 29.8826 19.801C29.8826 18.7787 29.6766 17.7664 29.2765 16.8219C28.9664 16.0899 28.5444 15.4097 28.026 14.8042L27.3191 15.4954C27.747 16.0083 28.097 16.5805 28.357 17.1943C28.7071 18.0207 28.8873 18.9065 28.8873 19.801C28.8873 20.6955 28.7071 21.5813 28.357 22.4077C28.097 23.0215 27.747 23.5937 27.319 24.1066L28.0259 24.7978Z"
      :fill="fill"
    />
    <path
      d="M26.0784 22.8936C26.8087 22.0263 27.213 20.934 27.213 19.801C27.213 18.6679 26.8088 17.5757 26.0785 16.7084L25.3706 17.4005C25.9167 18.082 26.2177 18.9263 26.2177 19.801C26.2177 20.6756 25.9166 21.52 25.3705 22.2015L26.0784 22.8936Z"
      :fill="fill"
    />
    <path
      d="M24.323 21.1773C24.4455 21.0575 24.552 20.9222 24.6393 20.7743C24.814 20.4784 24.906 20.1428 24.906 19.8012C24.906 19.4596 24.814 19.124 24.6393 18.8281C24.5519 18.6801 24.4454 18.5447 24.3229 18.425L23.6191 19.113C23.6804 19.1729 23.7337 19.2407 23.7774 19.3147C23.8647 19.4626 23.9107 19.6304 23.9107 19.8012C23.9107 19.972 23.8647 20.1398 23.7774 20.2877C23.7337 20.3617 23.6805 20.4293 23.6193 20.4892L24.323 21.1773Z"
      :fill="fill"
    />
    <rect
      x="6.05371"
      y="15.7847"
      width="6.90323"
      height="4.64516"
      rx="1.75806"
      fill="#D1D7DF"
      :stroke="fill"
    />
    <path
      d="M9.50586 15.8491V20.3653"
      :stroke="fill"
      stroke-width="1.12903"
    />
    <path
      d="M11.7627 18.1074L7.24657 18.1074"
      :stroke="fill"
      stroke-width="1.12903"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsVerticalsHomeCreditCard'
})

defineProps({
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>
